'use client';

import * as React from 'react';
import { captureWithSentry } from '~logic/sentry/captureWithSentry';
import { FormScreen } from '../../../screens/FormScreen/FormScreen';
import { HomeScreen } from '../../../screens/HomeScreen/HomeScreen';
import { OrderLockedScreen } from '../../../screens/LockedOrderScreen/OrderLockedScreen';
import { MenuScreen } from '../../../screens/MenuScreen/MenuScreen';
import { PaymentLockedScreen } from '../../../screens/PaymentLockedScreen/PaymentLockedScreen';
import { SubmittedScreen } from '../../../screens/SubmittedScreen/SubmittedScreen';
import { ValidatePaymentScreen } from '../../../screens/ValidatePaymentScreen/ValidatePaymentScreen';
import { useWaiterRouter } from '../hooks/useWaiterRouter'; // * as of now the routing in the Waiter app segment works as follows:
//  - all screens (different views showed on different URLs having its own Screen components)
//      are caught by a single Next.js page (a file in the /app folder used by Next’s internal router)
//      -> /[locale]/[[...pageUrl]]
//  - that page render this component that picks the right Screen component for the specific URL
//      (eg. both /cs/.../home and /cs/.../menu are caught by the same dynamic Next page that in both cases renders this router which will show the corresponding Screen)
// the reason for this solution is that we have very dynamic routes because of the nature of the app
//    – it is a "generic template" that renders specific data of the resolved company that is recognized based on parts the URL
//    as of now, there is no way in Next (that I know of) to have dynamic middle part of the URL (where the brand/branch/order_origin part is)
//    and static end part (where the screen name like /home or /menu is)
//    therefore we have to have the whole URL dynamic (hence the single Next page) and decide the Screen based on the last part of the URL
// URL parsing is done on the SS (to recognize invalid URLs & redirect ASAP) and the parsing result is then distributed via the RouteContextProvider

import { jsx as _jsx } from "react/jsx-runtime";

/**
 * routing of the waiter segment of the app
 */
export var WaiterRouter = function WaiterRouter() {
  var router = useWaiterRouter();

  var renderScreen = function renderScreen() {
    switch (router.screenRoute) {
      case 'home':
        return /*#__PURE__*/_jsx(HomeScreen, {});

      case 'menu':
        return /*#__PURE__*/_jsx(MenuScreen, {});

      case 'form':
        return /*#__PURE__*/_jsx(FormScreen, {});
      // order-placed is the last part of the order process
      // order-tracking is customer coming from email to see how is his order doing
      // both use-cases are served by the same screen (with minor tweaks)

      case 'order-placed':
        return /*#__PURE__*/_jsx(SubmittedScreen, {});

      case 'order-locked':
        return /*#__PURE__*/_jsx(OrderLockedScreen, {});

      case 'order-payment-locked':
        return /*#__PURE__*/_jsx(PaymentLockedScreen, {});

      case 'validate-payment':
        return /*#__PURE__*/_jsx(ValidatePaymentScreen, {});

      default:
        // this should never happen because invalid URL routes (that doesn’t have any screen linked to it)
        // should be already handle in SS (by redirecting to some known route/path)
        captureWithSentry({
          error: "Invalid screen route \"".concat(router.screenRoute, "\" was passed to the ShopRouter")
        });
        return null;
    }
  };

  return renderScreen();
};